import { Action, combineReducers } from '@ngrx/store';
import { objDiff } from '../utility';

import {
  _CLEAR,
  SET_REPORT_LIST_VIEW,
} from '../actions';

const reportListViewState = {
  loading: <boolean>false
};

export function reportListViewReducer(state = reportListViewState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return reportListViewState;
    case SET_REPORT_LIST_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export const reportReducers = combineReducers({
  reportListView: reportListViewReducer
});



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/reports.ts